<div class="row mt-2">
  <div class="col-3">
    <p>
      <span i18n="@@delete-message-history-label">Chatverlauf löschen</span>
      <app-hint i18n="@@delete-message-history-notice-hint">
        Es werden alle Chatverläufe, Zusammenfassungen etc. unwiderruflich gelöscht.
      </app-hint>
    </p>
  </div>
  <div class="col">
    <p-button
      size="small"
      severity="danger"
      [outlined]="true"
      (onClick)="this.confirmHistoryCleanup()"
      i18n-label="@@delete-message-history-button"
      label="Chatverlauf löschen"
    ></p-button>
  </div>
</div>
<p-confirmdialog [style]="{ width: '700px' }" />